import cn from "classnames";
import React, { useState } from "react";
import BidsTable from "./tables/bids";
import CarsTable from "./tables/cars";
import DriversTable from "./tables/drivers";
import TrailersTable from "./tables/trailers";

const resourceEnum = {
    CARS: "cars",
    TRAILERS: "trailers",
    DRIVERS: "drivers",
    BIDS: "bids",
};

const components = {
    [resourceEnum.CARS]: CarsTable,
    [resourceEnum.DRIVERS]: DriversTable,
    [resourceEnum.TRAILERS]: TrailersTable,
    [resourceEnum.BIDS]: BidsTable,
};

const ResourceDetails = (props) => {
    const [tab, setTab] = useState(resourceEnum.CARS);

    const TableComponent = components[tab];

    return (
        <>
            <div className="btn-toolbar mb-2 justify-content-center">
                <div className="btn-group">
                    <div
                        onClick={() => setTab(resourceEnum.CARS)}
                        className={cn("btn px-4", {
                            "btn-dark": tab === resourceEnum.CARS,
                            "btn-secondary": tab !== resourceEnum.CARS,
                        })}
                    >
                        Грузовики
                    </div>
                    <div
                        onClick={() => setTab(resourceEnum.TRAILERS)}
                        className={cn("btn px-4", {
                            "btn-dark": tab === resourceEnum.TRAILERS,
                            "btn-secondary": tab !== resourceEnum.TRAILERS,
                        })}
                    >
                        Прицепы
                    </div>
                    <div
                        onClick={() => setTab(resourceEnum.DRIVERS)}
                        className={cn("btn px-4", {
                            "btn-dark": tab === resourceEnum.DRIVERS,
                            "btn-secondary": tab !== resourceEnum.DRIVERS,
                        })}
                    >
                        Водители
                    </div>
                    <div
                        onClick={() => setTab(resourceEnum.BIDS)}
                        className={cn("btn px-4", {
                            "btn-dark": tab === resourceEnum.BIDS,
                            "btn-secondary": tab !== resourceEnum.BIDS,
                        })}
                    >
                        Заявки
                    </div>
                </div>
            </div>
            <TableComponent data={props[tab]} />
        </>
    );
};

export default ResourceDetails;
